"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3068],{

/***/ 55546:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _OptionPicker = __webpack_require__(91881);
var _mapUseOptionPicker2 = _interopRequireDefault(__webpack_require__(50295));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useOptionPicker(productForMap) {
  var isPro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _mapUseOptionPicker = (0, _mapUseOptionPicker2["default"])(productForMap),
    product = _mapUseOptionPicker.product,
    products = _mapUseOptionPicker.products,
    options = _mapUseOptionPicker.options;
  if (isPro) {
    products.forEach(function (productPro) {
      productPro.url = "".concat(productPro.url, "-").concat(productPro.sku);
    });
  }
  return (0, _OptionPicker.useOptionPicker)({
    products: products,
    options: options.map(function (o) {
      return _objectSpread(_objectSpread({}, o), {}, {
        missingProductStrategy: o.id === "color_trade_name" ? "alternative" : o.id === "size" ? "hidden" : "disabled"
      });
    }),
    initialProduct: product
  });
}
var _default = useOptionPicker;
exports["default"] = _default;

/***/ }),

/***/ 91881:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useOptionPicker = useOptionPicker;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getMatcherFromOption(option) {
  if (option.value) {
    return function (p, valId) {
      var val = option.value(p);
      var pValId = typeof val === "string" ? val : val.id;
      return valId === pValId;
    };
  }
  return option.matcher || function (p, valId) {
    return p.selectedOptions[option.id] === valId;
  };
}
function getValuesFromProduct(product, options) {
  var ret = {};
  options.forEach(function (option) {
    var matcher = getMatcherFromOption(option);
    ret[option.id] = option.values.find(function (v) {
      return matcher(product, v.id);
    });
  });
  return ret;
}
function getProductFromValues(values, options, products) {
  root: for (var i = 0; i < products.length; i++) {
    var product = products[i];
    for (var j = 0; j < options.length; j++) {
      var option = options[j];
      var matcher = getMatcherFromOption(option);
      if (!matcher(product, values[option.id].id)) {
        continue root;
      }
    }
    return product;
  }
}

/**
 * TODO: this is very inefficient, fix later.
 */
function allPossibleCases(arr) {
  if (arr.length == 1) {
    return arr[0];
  } else {
    var result = [];
    var allCasesOfRest = allPossibleCases(arr.slice(1)); // recur with the rest of array
    for (var i = 0; i < allCasesOfRest.length; i++) {
      for (var j = 0; j < arr[0].length; j++) {
        result.push(_objectSpread(_objectSpread({}, arr[0][j]), allCasesOfRest[i]));
      }
    }
    return result;
  }
}
function cartesianProductForValues(options) {
  var arr = options.map(function (o) {
    return o.values.map(function (v) {
      return (0, _defineProperty2["default"])({}, o.id, v);
    });
  });
  return allPossibleCases(arr);
}
function findAlternativeBasicStrategy(values, mainOption /* it can't change */, options, products) {
  var allCombinations = cartesianProductForValues((0, _toConsumableArray2["default"])(options).reverse());
  for (var i = 0; i < allCombinations.length; i++) {
    var iteratorValues = allCombinations[i];
    if (iteratorValues[mainOption.id].id !== values[mainOption.id].id) {
      // main option MUST be selected
      continue;
    }
    var product = getProductFromValues(iteratorValues, options, products);
    if (product) {
      return product;
    }
  }
}
function useOptionPicker() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$products = config.products,
    products = _config$products === void 0 ? [] : _config$products,
    initialProduct = config.initialProduct,
    _config$options = config.options,
    options = _config$options === void 0 ? [] : _config$options;
  var _useState = (0, _react.useState)(initialProduct),
    product = _useState[0],
    selectProduct = _useState[1];

  // calculate options

  options = options.map(function (option) {
    var newValues = Array.isArray(option.values) ? (0, _toConsumableArray2["default"])(option.values) : [];
    if (option.value) {
      products.forEach(function (product) {
        var ret = option.value(product);
        if (typeof ret === "string") {
          if (!newValues.find(function (x) {
            return x.id === ret;
          })) {
            newValues.push({
              id: ret,
              name: ret
            });
          }
        } else if (typeof ret === "object") {
          if (!newValues.find(function (x) {
            return x.id === ret.id;
          })) {
            newValues.push(ret);
          }
        } else {
          throw new Error("option.value must return string or object");
        }
      });
    }
    return _objectSpread(_objectSpread({}, option), {}, {
      values: newValues
    });
  });
  var selectedValues = getValuesFromProduct(product, options);
  var stateForValue = function stateForValue(selectedOption, selectedValue) {
    var optionId = typeof selectedOption === "object" ? selectedOption.id : selectedOption;
    var option = options.find(function (opt) {
      return opt.id === optionId;
    });
    var valueId = typeof selectedValue === "object" ? selectedValue.id : selectedValue;
    var value = option.values.find(function (val) {
      return val.id === valueId;
    });
    var strategy = option.missingProductStrategy || "hidden";
    var newValues = _objectSpread(_objectSpread({}, selectedValues), {}, (0, _defineProperty2["default"])({}, optionId, value));
    var newProduct = getProductFromValues(newValues, options, products);
    if (newProduct) {
      return newProduct;
    }
    if (strategy === "disabled") {
      return "disabled";
    }
    if (strategy === "alternative") {
      var alternative = findAlternativeBasicStrategy(newValues, option, options, products);
      if (alternative) {
        return alternative;
      }
    }
    return "hidden"; // default
  };
  var selectValue = function selectValue(option, value) {
    if (!value) return;
    var newProduct;
    if (value !== null && value !== void 0 && value.alternativeVariantAvailable) {
      var pickedOptions = {};
      value.alternativeVariantAvailable.pickedOptions.map(function (option) {
        pickedOptions[option.attribute_code] = option.name;
      });
      selectProduct(_objectSpread(_objectSpread({}, value.alternativeVariantAvailable), {}, {
        selectedOptions: pickedOptions
      }));
    } else {
      newProduct = stateForValue(option, value);
    }
    if (typeof newProduct !== "object") {
      console.warn("[useOptionPicker] you can't set option \"".concat(option, "\" to value \"").concat(value, "\" because this combination doesn't exist"));
      return;
    }
    selectProduct(newProduct);
  };
  var retOptions = [];
  options.forEach(function (option) {
    var showAsteriskInfo = false;
    var selectOptions = [];
    option.values.forEach(function (value) {
      var state = stateForValue(option, value);
      if (state === "hidden") {
        return;
      }
      var alternativeVariantAvailable = false;
      if ((option.id === "capacity" || option.id === "diameter") && state === "disabled") {
        if (initialProduct[option.id].id === value.id) {
          showAsteriskInfo = true;
          alternativeVariantAvailable = initialProduct;
        }
        initialProduct.otherVariants.map(function (variant) {
          var variantName = variant.pickedOptions.find(function (variant) {
            return variant.attribute_code === option.id;
          });
          if (variantName.name === value.id) {
            showAsteriskInfo = true;
            alternativeVariantAvailable = variant;
          }
        });
      }
      selectOptions.push(_objectSpread(_objectSpread({}, value), {}, {
        id: value.id,
        product: typeof state === "object" && state,
        alternativeVariantAvailable: alternativeVariantAvailable,
        disabled: !alternativeVariantAvailable && state === "disabled"
      }));
    });
    var selectProps = {
      options: selectOptions,
      value: selectedValues[option.id],
      placeholder: option.name,
      onChange: function onChange(val) {
        selectValue(option, val);
      }
    };
    retOptions.push(_objectSpread(_objectSpread({}, option), {}, {
      showAsteriskInfo: showAsteriskInfo,
      selectProps: selectProps
    }));
  });
  return {
    options: retOptions,
    selectedValues: selectedValues,
    selectValue: selectValue,
    product: product,
    selectProduct: selectProduct,
    stateForValue: stateForValue
  };
}

/***/ }),

/***/ 31543:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _SelectInline = _interopRequireDefault(__webpack_require__(71070));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  minifiedVersion: false,
  sameLabelForOptions: false
};
var OptionsSelector = function OptionsSelector(props) {
  var options = props.options,
    _props$minifiedVersio = props.minifiedVersion,
    minifiedVersion = _props$minifiedVersio === void 0 ? defaultProps.minifiedVersion : _props$minifiedVersio,
    colorSquare = props.colorSquare,
    pill = props.pill,
    selectNative = props.selectNative,
    formControl = props.formControl,
    gridWidth = props.gridWidth,
    _props$sameLabelForOp = props.sameLabelForOptions,
    sameLabelForOptions = _props$sameLabelForOp === void 0 ? defaultProps.sameLabelForOptions : _props$sameLabelForOp;
  var translations = {
    size: (0, _langLibrary["default"])("size"),
    color: (0, _langLibrary["default"])("color"),
    capacity: (0, _langLibrary["default"])("capacity"),
    diameter: (0, _langLibrary["default"])("diameter"),
    material: (0, _langLibrary["default"])("material"),
    shape: (0, _langLibrary["default"])("shape"),
    height: (0, _langLibrary["default"])("height"),
    width: (0, _langLibrary["default"])("width"),
    length: (0, _langLibrary["default"])("length"),
    depth: (0, _langLibrary["default"])("depth"),
    number_of_people: (0, _langLibrary["default"])("number of people"),
    available_versions: (0, _langLibrary["default"])("available versions")
  };
  var singlePickerStyle = {
    mb: "s7",
    width: "100%"
  };
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, options.map(function (option) {
    return option.values.length > 1 && __jsx(_Box["default"], {
      sx: option.id === "color_trade_name" ? _objectSpread(_objectSpread({}, singlePickerStyle), {}, {
        order: "1"
      }) : _objectSpread(_objectSpread({}, singlePickerStyle), {}, {
        order: "2"
      }),
      key: option.id
    }, __jsx(_Box["default"], {
      sx: !minifiedVersion && {
        pb: "s5"
      }
    }, option.id === "color_trade_name" && /*#__PURE__*/_react["default"].cloneElement(formControl, {
      label: sameLabelForOptions ? translations.available_versions : translations.color
    }, __jsx(_SelectInline["default"], option.selectProps, function (_ref) {
      var selectableProps = _ref.selectableProps;
      selectableProps.filter(function (selected) {
        return Array.isArray(selected.option.image);
      }).forEach(function (selected) {
        selected.option.image = selected.option.product.optionPickerImage;
      });
      return __jsx(_Grid["default"], {
        minItemWidth: gridWidth !== null && gridWidth !== void 0 ? gridWidth : 60,
        gap: 3
      }, selectableProps.map(function (props) {
        return /*#__PURE__*/_react["default"].cloneElement(colorSquare, _objectSpread({}, props));
      }));
    })), option.id === "size" && !minifiedVersion && /*#__PURE__*/_react["default"].cloneElement(formControl, {
      label: sameLabelForOptions ? translations.available_versions : translations.size
    }, __jsx(_SelectInline["default"], option.selectProps, function (_ref2) {
      var selectableProps = _ref2.selectableProps;
      return __jsx(_Grid["default"], {
        minItemWidth: 100,
        gap: 8
      }, selectableProps.map(function (props) {
        return /*#__PURE__*/_react["default"].cloneElement(pill, _objectSpread({}, props));
      }));
    })), option.id !== "color_trade_name" && option.id !== "size" && /*#__PURE__*/_react["default"].cloneElement(selectNative, _objectSpread(_objectSpread({}, option.selectProps), {}, {
      label: option.name === "capacity" ? "".concat(translations[option.name], " (l)") : translations[option.name],
      placeholder: sameLabelForOptions ? "" : translations[option.name]
    }))));
  }));
};
var _default = OptionsSelector;
exports.Z = _default;

/***/ }),

/***/ 76678:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _core = __webpack_require__(79329);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RadioRaw = _interopRequireDefault(__webpack_require__(4644));
var _excluded = ["disabled", "highlighted", "selected", "label", "invalid", "sx", "as", "children", "onFocus", "onBlur", "onSelect", "ignoreLabel", "id", "containerAdditionalStyles"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  ignoreLabel: false
};
var Selectable$ = function Selectable$(props) {
  var disabled = props.disabled,
    highlighted = props.highlighted,
    selected = props.selected,
    label = props.label,
    invalid = props.invalid,
    sx = props.sx,
    as = props.as,
    children = props.children,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    onSelect = props.onSelect,
    _props$ignoreLabel = props.ignoreLabel,
    ignoreLabel = _props$ignoreLabel === void 0 ? defaultProps.ignoreLabel : _props$ignoreLabel,
    id = props.id,
    containerAdditionalStyles = props.containerAdditionalStyles,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(false),
    focused = _useState[0],
    setFocused = _useState[1];
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
    css = _splitSx2[0],
    customSx = _splitSx2[1];
  if (!label && ignoreLabel === false) {
    console.warn("You didn't pass label prop to the Selectable. This will affect accessibility negatively.");
  }
  var state = _objectSpread({}, props);
  var content = children(state);
  var radioRef = (0, _react.useRef)(null);
  if (as === "link") {
    return __jsx(_LinkRaw["default"], (0, _extends2["default"])({
      title: label,
      sx: _objectSpread({
        $resetFocus: true,
        display: "block"
      }, css),
      onFocus: function onFocus(e) {
        setFocused(true);
        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);
        if (_onBlur) {
          _onBlur(e);
        }
      },
      id: id
    }, restProps), content);
  }
  if (as === "radio") {
    return __jsx(_Box["default"], {
      sx: _objectSpread({
        display: "block",
        position: "relative",
        cursor: "pointer"
      }, css),
      onClick: function onClick() {
        if (disabled) {
          return;
        }
        radioRef.current.focus();
        if (onSelect) {
          onSelect();
        }
      },
      className: focused ? "__commui_focus" : ""
    }, __jsx("label", {
      htmlFor: id,
      sx: {
        visibility: "hidden",
        position: "absolute"
      }
    }, label), __jsx(_RadioRaw["default"], (0, _extends2["default"])({}, restProps, {
      id: id,
      onFocus: function onFocus(e) {
        setFocused(true);
        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);
        if (_onBlur) {
          _onBlur(e);
        }
      },
      checked: selected,
      disabled: disabled,
      onChange: function onChange() {
        if (onSelect) {
          onSelect();
        }
      },
      inputRef: radioRef
    })), content);
  }
  return __jsx(_Box["default"], (0, _extends2["default"])({
    sx: _objectSpread(_objectSpread({}, containerAdditionalStyles), {}, {
      cursor: disabled ? "not-allowed" : "pointer"
    })
  }, restProps), content);
};
var _default = Selectable$;
exports["default"] = _default;

/***/ }),

/***/ 95532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _ButtonMinimalIcon = _interopRequireDefault(__webpack_require__(95574));
var _QuantityPicker = __webpack_require__(40753);
var _InputRaw = _interopRequireDefault(__webpack_require__(38164));
var _Select2Ui = _interopRequireDefault(__webpack_require__(84807));
var _Button = _interopRequireDefault(__webpack_require__(96088));
var _ItemRow = _interopRequireDefault(__webpack_require__(627));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconPlus = function IconPlus(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 19.338v-13h1.2v13h-1.2z"
  }));
};
IconPlus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconMinus = function IconMinus(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }));
};
IconMinus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var QuantityPicker = function QuantityPicker(props) {
  var counter = props.controller || (0, _QuantityPicker.useQuantityPicker)(props);
  var ref = (0, _react.useRef)(null);
  var inputsDisplay = {
    select: counter.exceedsSelectRange ? {
      display: "none"
    } : {
      display: "flex"
    },
    input: counter.exceedsSelectRange ? {
      display: "block"
    } : {
      display: "none"
    }
  };
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "inline-flex",
      flexDirection: "row",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "neutral",
      ":focus-within": {
        borderColor: "main"
      },
      color: "main"
    },
    _ref: ref
  }, __jsx(_ButtonMinimalIcon["default"], counter.buttonDecrementProps, __jsx(IconMinus, null)), __jsx(_InputRaw["default"], (0, _extends2["default"])({}, counter.inputProps, {
    sx: _objectSpread(_objectSpread({}, inputsDisplay.input), {}, {
      width: "50px",
      height: 44,
      textAlign: "center",
      font: "base_sans",
      lineHeight: 1,
      color: "main"
    }),
    type: "number",
    noFocus: true
  })), __jsx(_Select2Ui["default"], (0, _extends2["default"])({
    "data-test": "quantity-picker"
  }, counter.selectProps, {
    button: function button(_ref) {
      var value = _ref.value;
      return __jsx(_Button["default"], {
        sx: _objectSpread(_objectSpread({}, inputsDisplay.select), {}, {
          minWidth: 50,
          height: 44,
          justifyContent: "center",
          alignItems: "center",
          font: "base_sans",
          lineHeight: 1,
          flex: 1
        })
      }, value);
    },
    selectable: __jsx(_ItemRow["default"], null),
    allowEmpty: false,
    anchoredTo: ["window", null, ref],
    placement: ["center", null, "bottomLeft"],
    width: function width(_ref2) {
      var anchorRect = _ref2.anchorRect;
      return ["70vw", null, anchorRect.width];
    },
    maxHeight: ["90vh", null, "auto"],
    root: {
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)"
    }
  })), __jsx(_ButtonMinimalIcon["default"], counter.buttonIncrementProps, __jsx(IconPlus, null)));
};
var _default = QuantityPicker;
exports.Z = _default;

/***/ }),

/***/ 69759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _SelectableUI = _interopRequireDefault(__webpack_require__(76678));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var __jsx = _react["default"].createElement;
var defaultProps = {
  borderColor: "black",
  borderWidth: 1
};
var ColorSquare = function ColorSquare(props) {
  var _props$roundness = props.roundness,
    roundness = _props$roundness === void 0 ? true : _props$roundness,
    imageSize = props.imageSize,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? defaultProps.borderColor : _props$borderColor,
    _props$borderWidth = props.borderWidth,
    borderWidth = _props$borderWidth === void 0 ? defaultProps.borderWidth : _props$borderWidth;
  var additionalStyles = {
    borderRadius: roundness ? "50px" : 0,
    padding: roundness ? "5px" : 0
  };
  return __jsx(_SelectableUI["default"], (0, _extends2["default"])({}, props, {
    containerAdditionalStyles: {
      height: imageSize !== null && imageSize !== void 0 ? imageSize : [62, null, null, 64],
      width: imageSize !== null && imageSize !== void 0 ? imageSize : [62, null, null, 64]
    }
  }), function (_ref) {
    var _props$option;
    var highlighted = _ref.highlighted,
      selected = _ref.selected;
    return ((_props$option = props.option) === null || _props$option === void 0 ? void 0 : _props$option.image) && __jsx(_Image["default"], {
      image: props.option.image,
      cloudflareEnabled: __webpack_require__.g.__appConfig__.swatchesImageCloudflareEnabled,
      quality: __webpack_require__.g.__appConfig__.swatchesImageQuality,
      minified: true,
      highlighted: highlighted,
      selected: selected,
      roundness: roundness,
      additionalStyles: additionalStyles,
      borderColor: borderColor,
      borderSpace: imageSize > 0,
      borderWidth: borderWidth
    });
  });
};
var _default = ColorSquare;
exports.Z = _default;

/***/ }),

/***/ 39071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _iconList = _interopRequireDefault(__webpack_require__(13233));
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(15366));
var __jsx = _react["default"].createElement;
var LogoIcons = function LogoIcons(props) {
  var _icon$detailIcons$lan;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var addIcon = props.addIcon,
    option = props.option,
    _props$withMarginTop = props.withMarginTop,
    withMarginTop = _props$withMarginTop === void 0 ? false : _props$withMarginTop,
    _props$largeIcon = props.largeIcon,
    largeIcon = _props$largeIcon === void 0 ? false : _props$largeIcon;
  var icon = addIcon ? _iconList["default"].find(function (method) {
    return method.type === option.id;
  }) : "";
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row"
    }
  }, icon === null || icon === void 0 ? void 0 : (_icon$detailIcons$lan = icon.detailIcons[language]) === null || _icon$detailIcons$lan === void 0 ? void 0 : _icon$detailIcons$lan.map(function (logoIcon, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: largeIcon ? 190 : [50, null, 60],
        mt: largeIcon ? 0 : withMarginTop ? [30, "s5"] : "s5",
        mr: "s3",
        px: largeIcon ? 0 : "s3",
        py: "s4",
        borderRadius: 3,
        backgroundColor: logoIcon.background,
        svg: {
          maxWidth: largeIcon ? 190 : 60
        }
      }
    }, logoIcon.icon);
  }));
};
var _default = LogoIcons;
exports["default"] = _default;

/***/ }),

/***/ 31404:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Selectable = _interopRequireDefault(__webpack_require__(53910));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _usePriceWithCurrency = _interopRequireDefault(__webpack_require__(81890));
var _LogoIcons = _interopRequireDefault(__webpack_require__(39071));
var _mainIcon = _interopRequireDefault(__webpack_require__(83556));
var __jsx = _react["default"].createElement;
var Pill = function Pill(props) {
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var translations = {
    forFree: (0, _langLibrary["default"])("Free delivery")
  };
  var pillClick = props.pillClick ? props.pillClick : function () {};
  return __jsx(_Selectable["default"], (0, _extends2["default"])({}, props, {
    sx: {
      pointerEvents: props.selected ? "none" : "unset"
    }
  }), function (_ref) {
    var _props$subtitleColor, _option$rightLabel;
    var disabled = _ref.disabled,
      selected = _ref.selected,
      label = _ref.label,
      invalid = _ref.invalid,
      subtitle = _ref.subtitle,
      option = _ref.option,
      addIcon = _ref.addIcon,
      largeIcon = _ref.largeIcon;
    return __jsx(_Box["default"], {
      sx: {
        position: "relative",
        borderStyle: "solid",
        borderWidth: invalid ? "1px" : 0,
        borderColor: disabled ? "neutral" : invalid && selected ? "negative" : "neutral",
        font: props.fontSet ? props.fontSet.body : "body2",
        color: "main",
        bg: disabled ? "neutral100" : "white",
        minHeight: "64px",
        display: "flex",
        justifyContent: "space-between",
        px: "14px",
        alignItems: "center",
        py: "s7"
      },
      onClick: function onClick() {
        return pillClick(props.option.methodCode);
      }
    }, __jsx(_Box["default"], {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, !disabled && __jsx(_Box["default"], {
      sx: {
        width: "24px",
        height: "24px",
        minWidth: "24px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "main",
        borderRadius: "30px",
        mr: "s7",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }
    }, selected && __jsx(_Box["default"], {
      as: "span",
      sx: {
        width: "16px",
        height: "16px",
        bg: "main",
        borderRadius: "30px",
        display: "inline-block"
      }
    })), __jsx(_Box["default"], {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center"
      }
    }, __jsx(_Box["default"], {
      sx: {
        font: props.fontSet ? props.fontSet.bold : "s_sans_bold"
      }
    }, label), __jsx(_Box["default"], {
      sx: {
        font: props.fontSet ? props.fontSet.xs : "xs",
        color: (_props$subtitleColor = props.subtitleColor) !== null && _props$subtitleColor !== void 0 ? _props$subtitleColor : "beigeDarken",
        fontWeight: 700
      }
    }, subtitle), addIcon && __jsx(_LogoIcons["default"], {
      addIcon: addIcon,
      option: props.option,
      withMarginTop: option.price === 0,
      largeIcon: largeIcon
    }))), __jsx(_Box["default"], {
      sx: {
        textAlign: "right",
        alignSelf: [addIcon ? "flex-start" : "center", "center"],
        justifyContent: "flex-end"
      }
    }, option !== null && option !== void 0 && option.price ? priceWithCurrency(option.price) : option.price === 0 ? translations.forFree : (_option$rightLabel = option.rightLabel) !== null && _option$rightLabel !== void 0 ? _option$rightLabel : "", addIcon && __jsx(_mainIcon["default"], {
      type: props.option.id
    })));
  });
};
var _default = Pill;
exports.Z = _default;

/***/ }),

/***/ 50295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapUseOptionPicker = function mapUseOptionPicker(product) {
  var _product$otherVariant;
  product.otherVariants = product === null || product === void 0 ? void 0 : (_product$otherVariant = product.otherVariants) === null || _product$otherVariant === void 0 ? void 0 : _product$otherVariant.filter(function (variant) {
    return variant.isVisible;
  });
  var productPickedOptions = product.pickedOptions.map(function (option) {
    return {
      id: option.attribute_code,
      name: option.name
    };
  });
  var mapImageAttribute = function mapImageAttribute(data) {
    var swatch_image = data.swatch_image;
    if (!swatch_image) return;
    return {
      altText: swatch_image.alt,
      originalSrc: swatch_image.src,
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: swatch_image.src,
          w: 50,
          h: 50
        }]
      }]
    };
  };
  var options = [];
  productPickedOptions.map(function (productPickedOption) {
    var optionsFromVariants = [];
    var colorOptionPickerData = product.otherVariants.map(function (product) {
      var _product$pickedOption, _product$pickedOption2;
      return {
        optionPickerName: (_product$pickedOption = product.pickedOptions) === null || _product$pickedOption === void 0 ? void 0 : (_product$pickedOption2 = _product$pickedOption.find(function (option) {
          return option.attribute_code === "color_trade_name";
        })) === null || _product$pickedOption2 === void 0 ? void 0 : _product$pickedOption2.name,
        optionPickerImage: product.optionPickerImage
      };
    });
    product.otherVariants.map(function (variant) {
      return variant.pickedOptions;
    }).forEach(function (variantPickedOptions) {
      return variantPickedOptions.filter(function (variantPickedOption) {
        return variantPickedOption.attribute_code === productPickedOption.id;
      }).forEach(function (variantPickedOption) {
        var imageOrImages = function imageOrImages(images) {
          var _images$;
          return images.length === 1 ? (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.optionPickerImage : images;
        };
        var isUniqueOption = optionsFromVariants.filter(function (optionVariant) {
          return optionVariant.id === variantPickedOption.name;
        }).length === 0;
        if (isUniqueOption) {
          variantPickedOption.attribute_code === "color_trade_name" ? optionsFromVariants.push({
            id: variantPickedOption.name,
            name: variantPickedOption.name,
            image: __webpack_require__.g.__appConfig__.useDefaultColorPickerImage ? mapImageAttribute(variantPickedOption.data) : imageOrImages(colorOptionPickerData.filter(function (option) {
              return option.optionPickerName === variantPickedOption.name;
            }))
          }) : optionsFromVariants.push({
            id: variantPickedOption.name,
            name: variantPickedOption.name
          });
        }
      });
    });
    var values = [].concat(optionsFromVariants);
    if (values.filter(function (optionFromVariants) {
      return optionFromVariants.name === productPickedOption.name;
    }).length === 0) {
      var productOption = product.pickedOptions.filter(function (option) {
        return option.attribute_code === productPickedOption.id;
      })[0];
      values.push(productPickedOption.id === "color_trade_name" ? {
        id: productOption.name,
        name: productOption.name,
        image: __webpack_require__.g.__appConfig__.useDefaultColorPickerImage ? mapImageAttribute(productOption.data) : product.optionPickerImage
      } : {
        id: productOption.name,
        name: productOption.name
      });
    }
    options.push({
      id: productPickedOption.id,
      name: productPickedOption.id,
      values: values
    });
  });
  var mapSelectedOptions = function mapSelectedOptions(options) {
    var selectedOptions = {};
    options.map(function (option) {
      selectedOptions[option.attribute_code] = option.name;
    });
    return selectedOptions;
  };
  var mapAttributes = function mapAttributes(options) {
    var attributes = {};
    options.map(function (option) {
      attributes[option.attribute_code] = option.attribute_code === "color_trade_name" ? {
        id: option.name,
        name: option.name,
        image: mapImageAttribute(option.data)
      } : {
        id: option.name,
        name: option.name
      };
    });
    return attributes;
  };
  var products = product.otherVariants ? product.otherVariants.map(function (variant) {
    return _objectSpread(_objectSpread({}, variant), {}, {
      selectedOptions: mapSelectedOptions(variant.pickedOptions)
    }, mapAttributes(variant.pickedOptions));
  }) : [product];
  products.unshift(_objectSpread(_objectSpread({}, product), {}, {
    selectedOptions: _objectSpread({}, mapSelectedOptions(product.pickedOptions))
  }, mapAttributes(product.pickedOptions)));
  var sortOptions = function sortOptions(options) {
    var compareValuesOfKeyName = function compareValuesOfKeyName(keyName) {
      var sortOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
      return function innerSort(previous, next) {
        if (!previous.hasOwnProperty(keyName) || !next.hasOwnProperty(keyName)) {
          return 0;
        }
        var previousValue = typeof previous[keyName] === "string" ? parseFloat(previous[keyName]) : previous[keyName];
        var nextValue = typeof next[keyName] === "string" ? parseFloat(next[keyName]) : next[keyName];
        var comparison = 0;
        if (previousValue > nextValue) {
          comparison = 1;
        } else if (previousValue < nextValue) {
          comparison = -1;
        }
        return sortOrder === "desc" ? comparison * -1 : comparison;
      };
    };
    options.map(function (option) {
      if (option.id !== "color_trade_name") {
        option.values.sort(compareValuesOfKeyName("name"));
      } else {
        option.values.sort(compareValuesOfKeyName("sku"));
      }
    });
    return options;
  };
  options = sortOptions(options);
  return {
    products: products,
    options: options,
    product: products[0]
  };
};
var _default = mapUseOptionPicker;
exports["default"] = _default;

/***/ }),

/***/ 88778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _Container = _interopRequireDefault(__webpack_require__(58709));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  titleAs: "h3",
  centeredTitle: true,
  headerFont: "xxl",
  headerIndent: 0,
  descriptionFont: "base_sans_bold",
  withBorder: true,
  titleColor: "main",
  descriptionColor: "main",
  bottomBorderColor: "main",
  noSpaceAfterHeader: false,
  withContainer: false
};
var SectionWithConfigurableHeader = function SectionWithConfigurableHeader(props) {
  var title = props.title,
    link = props.link,
    children = props.children,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    _props$centeredTitle = props.centeredTitle,
    centeredTitle = _props$centeredTitle === void 0 ? defaultProps.centeredTitle : _props$centeredTitle,
    description = props.description,
    _props$headerFont = props.headerFont,
    headerFont = _props$headerFont === void 0 ? defaultProps.headerFont : _props$headerFont,
    _props$headerIndent = props.headerIndent,
    headerIndent = _props$headerIndent === void 0 ? defaultProps.headerIndent : _props$headerIndent,
    _props$noSpaceAfterHe = props.noSpaceAfterHeader,
    noSpaceAfterHeader = _props$noSpaceAfterHe === void 0 ? defaultProps.noSpaceAfterHeader : _props$noSpaceAfterHe,
    _props$descriptionFon = props.descriptionFont,
    descriptionFont = _props$descriptionFon === void 0 ? defaultProps.descriptionFont : _props$descriptionFon,
    _props$withBorder = props.withBorder,
    withBorder = _props$withBorder === void 0 ? defaultProps.withBorder : _props$withBorder,
    _props$titleColor = props.titleColor,
    titleColor = _props$titleColor === void 0 ? defaultProps.titleColor : _props$titleColor,
    _props$descriptionCol = props.descriptionColor,
    descriptionColor = _props$descriptionCol === void 0 ? defaultProps.descriptionColor : _props$descriptionCol,
    _props$bottomBorderCo = props.bottomBorderColor,
    bottomBorderColor = _props$bottomBorderCo === void 0 ? defaultProps.bottomBorderColor : _props$bottomBorderCo,
    additionalBlock = props.additionalBlock,
    mobileLinkButton = props.mobileLinkButton,
    _props$withContainer = props.withContainer,
    withContainer = _props$withContainer === void 0 ? defaultProps.withContainer : _props$withContainer;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var border = {
    borderBottomWidth: description ? "2px" : 0,
    borderBottomStyle: "solid",
    borderBottomColor: bottomBorderColor
  };
  var headerContent = __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: _objectSpread({
      textAlign: centeredTitle ? "center" : ["center", null, "left"],
      display: additionalBlock ? "flex" : description ? "inline-block" : "block",
      justifyContent: "space-between",
      font: headerFont,
      mb: description || noSpaceAfterHeader ? 0 : link ? ["200px"] : ["s8", null, null, "s10", null, null],
      pr: description ? [0, null, "s13"] : 0,
      pb: description ? "s5" : 0,
      pl: headerIndent,
      color: titleColor
    }, withBorder && border),
    as: titleAs
  }, additionalBlock ? __jsx(_Box["default"], null, title) : title, additionalBlock && __jsx(_Box["default"], null, additionalBlock)), description && __jsx(_Box["default"], {
    sx: {
      font: descriptionFont,
      color: descriptionColor,
      mb: "s10",
      mt: "s5"
    }
  }, description), link && __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: "s_sans",
      mt: noSpaceAfterHeader ? "s5" : 0,
      mb: ["s8", null, null, "s10", null, null],
      color: "main",
      textDecoration: "underline",
      cursor: "pointer"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: {
      url: (link === null || link === void 0 ? void 0 : link.url.indexOf("/")) === 0 ? link.url.replace("/", "") : link.url
    }
  }, __jsx(_LinkRaw["default"], {
    title: link.name
  }, link.name))));
  return withContainer ? __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Container["default"], null, headerContent), children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "") : __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, headerContent, " ", children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "");
};
var _default = SectionWithConfigurableHeader;
exports.Z = _default;

/***/ }),

/***/ 50014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_OptionsSelector; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../components-new/dist/OptionsSelector/index.js
var OptionsSelector = __webpack_require__(31543);
// EXTERNAL MODULE: ../components-new/dist/selectables/ColorSquare/index.js
var ColorSquare = __webpack_require__(69759);
;// CONCATENATED MODULE: ./src/components/selectables/ColorSquare/index.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ColorSquare_ColorSquare = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ColorSquare/* default */.Z, _objectSpread({}, props));
};
/* harmony default export */ var selectables_ColorSquare = (ColorSquare_ColorSquare);

// EXTERNAL MODULE: ./src/components/selectables/Pill/index.js
var Pill = __webpack_require__(18335);
// EXTERNAL MODULE: ../components-new/dist/SelectInDialog/index.js
var SelectInDialog = __webpack_require__(74047);
// EXTERNAL MODULE: ./src/components/formControls/FormControl.js
var FormControl = __webpack_require__(42361);
;// CONCATENATED MODULE: ./src/components/OptionsSelector/index.js







function OptionsSelector_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OptionsSelector_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OptionsSelector_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var OptionsSelector_OptionsSelector = function(props) {
    var propsExt = OptionsSelector_objectSpread({}, props, {
        colorSquare: /*#__PURE__*/ (0,jsx_runtime.jsx)(selectables_ColorSquare, {}),
        pill: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {}),
        selectNative: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInDialog/* default */.Z, {}),
        formControl: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {})
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsSelector/* default */.Z, OptionsSelector_objectSpread({}, propsExt)));
};
/* harmony default export */ var components_OptionsSelector = (OptionsSelector_OptionsSelector);


/***/ }),

/***/ 42361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function FormControl(_param) {
    var children = _param.children, label = _param.label, error = _param.error, sx = _param.sx, _controlRef = _param._controlRef, _asFieldset = _param.asFieldset, asFieldset = _asFieldset === void 0 ? false : _asFieldset, restProps = _objectWithoutProperties(_param, [
        "children",
        "label",
        "error",
        "sx",
        "_controlRef",
        "asFieldset"
    ]);
    var control = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    // Normalize error field
    error = Array.isArray(error) ? error : error ? [
        error
    ] : [];
    error = error.map(function(e) {
        return typeof e === "string" ? {
            text: e
        } : e;
    });
    var shouldShowLabel = !control.type.labelInside;
    var invalid = restProps.invalid, focused = restProps.focused;
    invalid = invalid || error.length > 0;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default()), {
        as: asFieldset ? "fieldset" : "div",
        sx: sx,
        children: [
            shouldShowLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default()), {
                sx: {
                    font: "xxs_caps",
                    color: "neutral700",
                    mb: "s4",
                    display: "block"
                },
                as: asFieldset ? "legend" : "label",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(control, _objectSpread({}, restProps, {
                    invalid: invalid
                }))
            }),
            error.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default()), {
                sx: {
                    color: "negative",
                    font: "body2",
                    mt: 2,
                    ml: 2,
                    mb: "s4"
                },
                children: error.map(function(e) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_2___default()), {
                        as: "p",
                        children: e.text
                    }, e.text);
                })
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormControl);


/***/ }),

/***/ 72565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_quantityPickers_QuantityPicker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95532);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var QuantityPicker = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_quantityPickers_QuantityPicker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuantityPicker);


/***/ }),

/***/ 18335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_selectables_Pill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31404);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Pill = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_selectables_Pill__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Pill);


/***/ })

}]);